import { NftDefaultValue } from "../../../defalult/NftDefaultValue";
import addEmptyBlocks from "../../../utils/addEmptyBlocks";
import { NftCard } from "../../Products/NftCard/NftCard";
import { SingleCollectionContentHeader, SingleCollectionContentMain, SingleCollectionContentWrapper } from "./SingleCollectionContent.styled";

const Nfts = NftDefaultValue;

export const SingleCollectionContent = () => {
  return (
    <SingleCollectionContentWrapper>
      <SingleCollectionContentHeader>
        <div>
          <h4>FLOOR PRICE</h4>
          <span>6 TON</span>
        </div>
        <div>
          <h4>ITEMS</h4>
          <span>6</span>
        </div>
        <div>
          <h4>TOTAL VOLUME</h4>
          <span>660 TON</span>
        </div>
      </SingleCollectionContentHeader>
      <SingleCollectionContentMain>
        {Nfts.map((product, i) => (
          <NftCard product={product} key={i} />
        ))}
      </SingleCollectionContentMain>
    </SingleCollectionContentWrapper>
  );
};
